import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import _classCallCheck from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
var defaultMaskConfig = {
  excludeCountry: true
};
/**
 * Phone mask is an BiFunctor providing the map (mask) and unmap (unmask) methods.
 */

var PhoneMask = /*#__PURE__*/function () {
  function PhoneMask() {
    _classCallCheck(this, PhoneMask);
  }

  _createClass(PhoneMask, null, [{
    key: "mask",
    value: function mask(phone) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMaskConfig;
      return config.excludeCountry ? phone.replace(/^(\d\d)(\d\d)(\d{5})(\d{4})/, '($2) $3-$4') : phone.replace(/^(\d\d)(\d\d)(\d{5})(\d{4})/, '+$1 ($2) $3-$4');
    }
  }, {
    key: "unmask",
    value: function unmask(phone) {
      return phone.replace(/[^\d]+/g, '');
    }
  }, {
    key: "maskWithoutCountry",
    value: function maskWithoutCountry(phone) {
      return phone.replace(/^(\d\d)(\d{5})(\d{4})$/, '($1) $2-$3');
    }
  }, {
    key: "validate",
    value: function validate(phone) {
      return /^(\d\d)(\d{5})(\d{4})$/.test(phone);
    }
  }]);

  return PhoneMask;
}();

export { PhoneMask as default };